import { Stack } from "@mui/joy";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import CustomTypography from "components/common/CustomTypography";
import { theme } from "styles/theme";

// 웹 — 자동으로 채우는 활동지 위에 떠 있는 잠금 안내 (본문은 흐리게 잠근다, TaskContent)
export default function AutoFillLockNotice() {
  return (
    <Stack
      role="status"
      direction="row"
      alignItems="center"
      spacing={1}
      sx={{
        position: "absolute",
        top: "12px",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 10,
        maxWidth: "calc(100% - 32px)",
        minHeight: "44px",
        px: "16px",
        borderRadius: "999px",
        border: `1px solid ${theme.vars.palette.Border.SuperWeak}`,
        backgroundColor: theme.vars.palette.Surface.Forward,
        boxShadow: "0 8px 24px rgba(32,39,43,0.14)",
        boxSizing: "border-box",
        pointerEvents: "none",
      }}
    >
      <LockRoundedIcon
        aria-hidden
        sx={{
          flexShrink: 0,
          fontSize: "16px",
          color: theme.vars.palette.Content.Highlight,
        }}
      />
      <CustomTypography
        variant={"Caption"}
        sx={{
          fontWeight: 700,
          color: theme.vars.palette.Content.Strong,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        Agent가 채우는 중이라 수정할 수 없어요
      </CustomTypography>
    </Stack>
  );
}
